import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const contactsTableTooltips = TOOLTIPS_TEXTS.contactsTable;

export const BASE_TEAM_MEMBERS_ACTIVE_OPTIONS: TableOption[] = [];

export const BASE_TEAM_MEMBERS_ARCHIVED_OPTIONS: TableOption[] = [];

export const BASE_TEAM_MEMBERS_TABLE_CONFIG: TableSource = {
  displayedColumns: [
    'checkbox',
    'name',
    'jobTitle',
    'contactType',
    // 'companyType',
    // 'company',
    'email',
    'mobilePhone'
  ],
  displayedTitles: [
    'All',
    'Name',
    'Job Title',
    'Contact Type',
    // 'Company Type',
    // 'Company',
    'Email',
    'Mobile Phone'
  ],
  columnsConfig: [
    { sorting: false },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true }
  ],
  displayedTooltips: [
    '',
    contactsTableTooltips.name,
    contactsTableTooltips.jobTitle,
    contactsTableTooltips.contactType,
    // contactsTableTooltips.companyType,
    // contactsTableTooltips.company,
    contactsTableTooltips.email,
    contactsTableTooltips.phone
  ],
  options: null,
  dataSource: []
};
